import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Layout,
  Button,
  Space,
  List,
  Avatar,
  Empty,
} from 'antd'
import {
  ArrowLeftOutlined,
  MessageOutlined,
  StarOutlined,
  StarFilled,
  UserOutlined,
} from '@ant-design/icons'
import { teamApi } from '../api/team'
import { fragmentApi } from '../api/fragment'
import { TeamInfo, FragmentInfo } from '../types'

const { Header, Content } = Layout

export default function TeamDetail() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [team, setTeam] = useState<TeamInfo | null>(null)
  const [fragments, setFragments] = useState<FragmentInfo[]>([])
  const [loading, setLoading] = useState(false)

  const teamId = id ? parseInt(id) : 0

  const loadTeam = async () => {
    if (!teamId) return
    const result = await teamApi.getTeamDetail(teamId)
    setTeam(result)
  }

  const loadFragments = async () => {
    if (!teamId) return
    setLoading(true)
    try {
      const result = await fragmentApi.getTeamFragments(teamId, {})
      setFragments(result || [])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadTeam()
    loadFragments()
  }, [teamId])

  const handleReply = (fragment: FragmentInfo) => {
    console.log('Reply to fragment:', fragment)
  }

  const handleToggleFavorite = async (fragment: FragmentInfo) => {
    await fragmentApi.toggleFavorite(fragment.id)
    loadFragments()
  }

  if (!team) {
    return (
      <Layout className="h-full">
        <Content className="p-6 flex items-center justify-center">
          <Empty description="加载中..." />
        </Content>
      </Layout>
    )
  }

  return (
    <Layout className="h-full">
      <Header className="bg-white border-b border-gray-200 flex items-center justify-between px-6">
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/')}>
            返回
          </Button>
          <h2 className="text-xl font-bold">{team.name}</h2>
        </Space>
      </Header>

      <Content className="p-6">
        <div className="bg-white rounded-lg p-4 mb-4 shadow-sm">
          <p className="text-gray-600">团队详情页面</p>
        </div>

        <List
          loading={loading}
          dataSource={fragments}
          locale={{ emptyText: <Empty description="暂无碎片" /> }}
          renderItem={(fragment) => (
            <List.Item
              key={fragment.id}
              className="bg-white rounded-lg shadow-sm p-4 mb-3"
              actions={[
                <Button type="text" icon={<MessageOutlined />} onClick={() => handleReply(fragment)}>回复</Button>,
                <Button
                  type="text"
                  icon={fragment.isFavorite ? <StarFilled /> : <StarOutlined />}
                  onClick={() => handleToggleFavorite(fragment)}
                />
              ]}
            >
              <List.Item.Meta
                avatar={<Avatar src={fragment.userAvatar} icon={<UserOutlined />} />}
                title={fragment.userNickname}
                description={fragment.content}
              />
            </List.Item>
          )}
        />
      </Content>
    </Layout>
  )
}
